// Use commented import IF KEY_SETTINGS section below is uncommented in the future.
// import {AppstoreOutlined, LayoutOutlined, SettingOutlined} from "@ant-design/icons";
import {AppstoreOutlined, LayoutOutlined} from "@ant-design/icons";

export const KEY_EMAIL_TEMPLATES = "EMAIL_TEMPLATES";
export const KEY_BRANDING = "BRANDING";
export const KEY_SETTINGS = "SETTINGS";

export const TAB_DATA = [
    {
        tabKey: KEY_EMAIL_TEMPLATES,
        icon: LayoutOutlined,
        altText: "Email Templates",
        label: "Email Templates",
        route: "/webchat/email-templates"
    },
    {
        tabKey: KEY_BRANDING,
        icon: AppstoreOutlined,
        altText: "Branding",
        label: "Branding",
        route: "/webchat/branding"
    },
    // TODO: Uncomment when settings page is ready
    // {
    //     tabKey: KEY_SETTINGS,
    //     icon: SettingOutlined,
    //     altText: "Settings",
    //     label: "Settings",
    //     route: "/webchat/settings"
    // },
];